export const INCHES_IN_FOOT = 12;
export const FEET_TO_METERS_CONVERSION_FACTOR = 0.3048;
export const BMI_DECIMAL_PRECISION = 2;
export const MAX_QUESTIONS_PER_ROW = 3;
